import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../../../Store';

function ImprintLink({ label, linkId = 'n/a' }) {
	const state = useContext(AppContext)[0];

	return (
		<a
			href={state.imprintUrl}
			target="_blank"
			id={linkId}
			rel="noreferrer"
		>
			{label}
		</a>
	);
}

export default ImprintLink;

ImprintLink.propTypes = {
	label: PropTypes.string.isRequired,
	linkId: PropTypes.string,
};